import React from "react";
import Box from "@mui/material/Box";

const BusinessNotFound = ({ errorMessage, navigate }) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        width: "100%",

        gap: "16px",
      }}
    >
      <Box
        sx={{
          fontSize: "24px",
          fontWeight: 600,
          color: "#061522",
          fontFamily: "Inter",
        }}
      >
        Business Not Found
      </Box>
      <Box
        sx={{
          fontSize: "16px",
          color: "#405261",
          fontFamily: "Inter",
          textAlign: "center",
        }}
      >
        {"This business does not exist or is no longer available."}
      </Box>
    </Box>
  );
};

export default BusinessNotFound;